@if (content) {
  <div class="accordion">
    <h5 class="accordion-title">{{content.title}}</h5>
    <div ngbAccordion #accordionContainer="ngbAccordion" [closeOthers]="true">
      @for (item of content.items; track item; let i = $index) {
        <div ngbAccordionItem>
          <div ngbAccordionHeader>
            <button ngbAccordionButton>{{item.title}}</button>
          </div>
          <div ngbAccordionCollapse id="{{ 'attr' + i }}">
            <div ngbAccordionBody>
              <wagtail-page-element-factory [contentElements]="item.contents"></wagtail-page-element-factory>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

